import { createSessionStore } from "./store";
export const avatar = createSessionStore(null, 'avatar');
